export interface Movie {
  id: string;
  title: string;
  type: '电影' | '电视剧';
  year: number;
  region: string;
  rating: number;
  hot: number;
  cover: string;
  duration: string;
  releaseDate: string;
  director: string;
  cast: string[];
  genres: string[];
  summary: string;
  gallery: string[];
}

export const movies: Movie[] = [
  {
    id: 'm01',
    title: '霓虹迷城',
    type: '电影',
    year: 2024,
    region: '日本',
    rating: 8.6,
    hot: 9820,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20moody%20deep%20blue%20night%20city%20skyline%20with%20warm%20orange%20neon%20reflections%2C%20minimal%20elegant%20composition%2C%20mysterious%20atmosphere%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-01&orientation=portrait',
    duration: '118分钟',
    releaseDate: '2024-09-14',
    director: '宫本隼人',
    cast: ['河北彩花', '白石怜', '高桥南', '森川葵'],
    genres: ['悬疑', '都市', '剧情'],
    summary:
      '深夜的霓虹灯下，一名调查记者循着一段模糊的录音，在城市的光影缝隙里追查一桩沉寂多年的旧案。随着线索层层展开，她不得不重新审视自己与这座城市的关系。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20rain%20slick%20city%20street%20at%20night%20with%20blue%20and%20orange%20neon%20light%20reflections%2C%20moody%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-01a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20lone%20figure%20silhouette%20walking%20through%20glowing%20urban%20alley%2C%20deep%20blue%20tones%20with%20warm%20accents%2C%20moody%20professional%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-01b&orientation=landscape',
    ],
  },
  {
    id: 'm02',
    title: '深海回声',
    type: '电影',
    year: 2023,
    region: '日本',
    rating: 8.2,
    hot: 7420,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20deep%20ocean%20blue%20with%20soft%20light%20rays%20from%20above%2C%20calm%20mysterious%20underwater%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-02&orientation=portrait',
    duration: '126分钟',
    releaseDate: '2023-11-03',
    director: '佐藤一树',
    cast: ['河北彩花', '中村雅', '小林遥'],
    genres: ['剧情', '悬疑'],
    summary:
      '一场海上事故之后，幸存者带着无人相信的记忆回到陆地。为了找回真相，她一次次潜入深海，也一次次潜入自己不愿面对的过去。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20vast%20calm%20ocean%20surface%20at%20dawn%20with%20soft%20blue%20and%20golden%20light%2C%20minimal%20serene%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-02a&orientation=landscape',
    ],
  },
  {
    id: 'm03',
    title: '樱花之约',
    type: '电视剧',
    year: 2024,
    region: '日本',
    rating: 7.9,
    hot: 6880,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20art%2C%20soft%20pink%20blossoms%20against%20deep%20blue%20sky%2C%20gentle%20spring%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-03&orientation=portrait',
    duration: '全12集',
    releaseDate: '2024-03-28',
    director: '田中惠',
    cast: ['河北彩花', '木村光', '佐佐木凛'],
    genres: ['爱情', '都市', '剧情'],
    summary:
      '一对多年未见的好友在樱花季节重逢，他们约定去看一场从未看成的花海。旧时光与当下交错，关于承诺与成长的故事缓缓展开。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20blossom%20trees%20lined%20path%20in%20soft%20spring%20light%2C%20warm%20gentle%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-03a&orientation=landscape',
    ],
  },
  {
    id: 'm04',
    title: '夜色温柔',
    type: '电影',
    year: 2022,
    region: '日本',
    rating: 8.0,
    hot: 6110,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20dim%20warm%20street%20lamp%20glow%20in%20misty%20blue%20evening%2C%20intimate%20quiet%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-04&orientation=portrait',
    duration: '112分钟',
    releaseDate: '2022-12-09',
    director: '宫本隼人',
    cast: ['河北彩花', '藤井翔', '森川葵'],
    genres: ['剧情', '文艺'],
    summary:
      '一位在城市里独自生活的女子，在小巷深处的旧唱片店遇到改变她生活节奏的人。夜色之下，两个灵魂慢慢靠近又轻轻走开。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20cozy%20vintage%20record%20store%20interior%20with%20warm%20dim%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-04a&orientation=landscape',
    ],
  },
  {
    id: 'm05',
    title: '东京往事',
    type: '电视剧',
    year: 2023,
    region: '日本',
    rating: 8.4,
    hot: 8560,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20art%2C%20retro%20city%20street%20in%20sepia%20and%20deep%20blue%20tones%2C%20nostalgic%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-05&orientation=portrait',
    duration: '全16集',
    releaseDate: '2023-06-15',
    director: '小林遥',
    cast: ['河北彩花', '高桥南', '中村雅', '白石怜'],
    genres: ['年代', '剧情', '家庭'],
    summary:
      '从上世纪末到今天，一个普通家庭的三个孩子各自奔向不同的人生。老街的钟声里，藏着他们共同的记忆与和解。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20town%20alley%20with%20warm%20afternoon%20sun%2C%20nostalgic%20vintage%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-05a&orientation=landscape',
    ],
  },
  {
    id: 'm06',
    title: '光的轨迹',
    type: '电影',
    year: 2024,
    region: '日本',
    rating: 8.8,
    hot: 10240,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20dramatic%20light%20beams%20cutting%20through%20dark%20blue%20space%20with%20warm%20orange%20edge%2C%20hopeful%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-06&orientation=portrait',
    duration: '134分钟',
    releaseDate: '2024-07-19',
    director: '佐藤一树',
    cast: ['河北彩花', '木村光', '藤井翔'],
    genres: ['科幻', '剧情', '悬疑'],
    summary:
      '在一座依赖人造光源运转的城市里，一位光轨工程师发现了被隐藏的运行真相。为了守住所有人的白天，她决定走向最黑暗的地方。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20futuristic%20city%20with%20glowing%20light%20lines%2C%20deep%20blue%20and%20warm%20orange%2C%20sci%20fi%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-06a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20lone%20engineer%20silhouette%20before%20vast%20glowing%20light%20structure%2C%20dramatic%20sci%20fi%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-06b&orientation=landscape',
    ],
  },
  {
    id: 'm07',
    title: '雨季到来之前',
    type: '电影',
    year: 2021,
    region: '日本',
    rating: 7.6,
    hot: 4320,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20overcast%20sky%20with%20rain%20clouds%20over%20deep%20blue%20horizon%2C%20melancholic%20calm%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-07&orientation=portrait',
    duration: '108分钟',
    releaseDate: '2021-05-21',
    director: '田中惠',
    cast: ['河北彩花', '佐佐木凛'],
    genres: ['剧情', '文艺'],
    summary:
      '雨季来临前的一周，小镇上的人们各自酝酿着告别。一场即将到来的雨，把所有犹豫都推到了阳光下。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20quiet%20small%20town%20before%20rain%2C%20muted%20blue%20tones%2C%20calm%20film%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-07a&orientation=landscape',
    ],
  },
  {
    id: 'm08',
    title: '无声告白',
    type: '电视剧',
    year: 2022,
    region: '日本',
    rating: 8.1,
    hot: 5990,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20art%2C%20abstract%20sound%20wave%20lines%20in%20deep%20blue%20with%20warm%20accent%2C%20restrained%20emotional%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-08&orientation=portrait',
    duration: '全10集',
    releaseDate: '2022-08-12',
    director: '小林遥',
    cast: ['河北彩花', '白石怜', '小林遥'],
    genres: ['家庭', '剧情'],
    summary:
      '一个习惯用文字代替言语的家庭，在多年后因为一封信重新聚在一起。那些从未说出口的话，终于被听见。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20family%20dining%20room%20with%20warm%20window%20light%2C%20quiet%20emotional%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-08a&orientation=landscape',
    ],
  },
  {
    id: 'm09',
    title: '海街物语',
    type: '电影',
    year: 2023,
    region: '日本',
    rating: 7.8,
    hot: 5210,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20seaside%20street%20at%20golden%20hour%20with%20deep%20blue%20sea%20beyond%2C%20gentle%20warm%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-09&orientation=portrait',
    duration: '120分钟',
    releaseDate: '2023-09-08',
    director: '宫本隼人',
    cast: ['河北彩花', '中村雅', '木村光'],
    genres: ['剧情', '家庭'],
    summary:
      '临海小镇被一座老码头牵连着几代人的命运。当拆迁通知到来，一个归乡的人开始重新理解家的含义。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20old%20seaside%20pier%20at%20sunset%20with%20warm%20golden%20and%20blue%20tones%2C%20nostalgic%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-09a&orientation=landscape',
    ],
  },
  {
    id: 'm10',
    title: '午夜列车',
    type: '电影',
    year: 2024,
    region: '日本',
    rating: 8.3,
    hot: 8130,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20night%20train%20window%20streaked%20with%20blue%20light%20and%20warm%20interior%20glow%2C%20suspenseful%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-10&orientation=portrait',
    duration: '124分钟',
    releaseDate: '2024-11-22',
    director: '佐藤一树',
    cast: ['河北彩花', '高桥南', '藤井翔'],
    genres: ['悬疑', '惊悚'],
    summary:
      '末班列车驶出站台后，车厢里的乘客发现彼此都指向同一桩旧事。终点站之前，真相必须被揭开。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20empty%20night%20train%20carriage%20with%20blue%20window%20light%2C%20moody%20suspense%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-10a&orientation=landscape',
    ],
  },
  {
    id: 'm11',
    title: '春日觉醒',
    type: '电视剧',
    year: 2023,
    region: '日本',
    rating: 7.7,
    hot: 4760,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20art%2C%20young%20green%20shoots%20against%20deep%20blue%20morning%20sky%2C%20fresh%20hopeful%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-11&orientation=portrait',
    duration: '全14集',
    releaseDate: '2023-04-06',
    director: '田中惠',
    cast: ['河北彩花', '森川葵', '佐佐木凛'],
    genres: ['青春', '剧情'],
    summary:
      '四名年轻人在同一间排练室相遇，用一场演出告别各自的迷茫。春天来临时，他们终于敢于选择自己想要的未来。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20bright%20rehearsal%20room%20with%20soft%20spring%20light%2C%20youthful%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-11a&orientation=landscape',
    ],
  },
  {
    id: 'm12',
    title: '星尘之下',
    type: '电影',
    year: 2022,
    region: '日本',
    rating: 8.5,
    hot: 9340,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20art%2C%20night%20sky%20full%20of%20stars%20above%20dark%20blue%20landscape%2C%20dreamy%20romantic%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail%20professional%20key%20art%2C%20no%20text&width=600&height=900&seq=hebeimovie-cover-12&orientation=portrait',
    duration: '128分钟',
    releaseDate: '2022-10-14',
    director: '小林遥',
    cast: ['河北彩花', '白石怜', '木村光'],
    genres: ['爱情', '奇幻', '剧情'],
    summary:
      '两个相信星象的人在一座观测站相识。他们约定，当同一片星空再次出现时，就去实现各自最勇敢的愿望。',
    gallery: [
      'https://readdy.ai/api/search-image?query=Cinematic%20still%2C%20observatory%20under%20vast%20starry%20night%20sky%2C%20deep%20blue%20dreamy%20film%20aesthetic%2C%20no%20text&width=800&height=500&seq=hebeimovie-still-12a&orientation=landscape',
    ],
  },
];